<search-dialog-page [model]="model" (onAction)="action($event)">
  <div class="container-fluid">
    <ep-row class="col-12">
      <form
        (ngSubmit)="dsCollection.refresh(); model.dirty = false"
        (keypress)="model.dirty = true"
        style="width: 100%; margin-bottom: 0px; margin-top: 0px"
      >
        <ep-row>
          <div class="col-12 col-lg-4">
            <div class="unity-form-group" style="display: inline-block">
              <label for="Indv_First_Name">First Name</label>
              <input
                myFocus
                type="text"
                name="Indv_First_Name"
                [(ngModel)]="dsCollection.criteria.Indv_First_Name"
                ngControl="Indv_First_Name"
                (valueChange)="model.dirty = true"
              />
            </div>
          </div>

          <div class="col-12 col-lg-4">
            <div class="unity-form-group" style="display: inline-block">
              <label for="Indv_Middle_Name">Middle Name</label>
              <input
                type="text"
                name="Indv_Middle_Name"
                [(ngModel)]="dsCollection.criteria.Indv_Middle_Name"
                ngControl="Indv_Middle_Name"
                (valueChange)="model.dirty = true"
              />
            </div>
          </div>

          <div class="col-12 col-lg-4">
            <div class="unity-form-group" style="display: inline-block">
              <label for="Indv_Last_Name">Last Name</label>
              <input
                type="text"
                name="Indv_Last_Name"
                [(ngModel)]="dsCollection.criteria.Indv_Last_Name"
                ngControl="Indv_Last_Name"
                (valueChange)="model.dirty = true"
              />
            </div>
          </div>

          <div class="col-12 col-lg-4" *ngIf="canViewDOBData == 'Y'">
            <div class="unity-form-group" style="display: inline-block">
              <label for="Birth_Date">DOB</label>
              <ep-date-input
                [noLabel]="true"
                [(ngModel)]="dsCollection.criteria.Birth_Date"
                ngControl="Birth_Date"
                (ngModelChange)="model.dirty = true"
                name="Birth_Date"
                [format]="'date'"
                [popupOnFocus]="false"
              ></ep-date-input>
            </div>
          </div>

          <div class="col-12 col-lg-4" *ngIf="canViewDLData == 'Y'">
            <div class="unity-form-group" style="display: inline-block">
              <label for="Drvr_Lic_Num">Driver Lic #</label>
              <input
                type="text"
                name="Drvr_Lic_Num"
                [(ngModel)]="dsCollection.criteria.Drvr_Lic_Num"
                ngControl="Drvr_Lic_Num"
                (valueChange)="model.dirty = true"
              />
            </div>
          </div>

          <div class="col-12 col-lg-4">
            <unity-button-old
              class="pull-right margin-l-5"
              style="margin-top: 16px"
              type="submit"
              classes="primary"
              [loading]="dsCollection && dsCollection.status == 'Loading'"
              [dirty]="model.dirty"
            >
              Search
            </unity-button-old>
          </div>
        </ep-row>
      </form>
    </ep-row>

    <ep-row>
      <div
        class="col-12"
        style="margin: 5px 5px 5px 5px; border-top: solid 1px; padding-top: 5px; border-top-color: #e5e3e3"
      >
        <ep-filter-input
          #profileFilter
          style="margin-bottom: 5px"
          [filter]="{ filterKey: '[GLOBAL]', maxDepth: 5 }"
        ></ep-filter-input>
        <span>
          <unity-button-old
            classes="secondary"
            (click)="
              select({
                Indv_First_Name: dsCollection.criteria.Indv_First_Name,
                Indv_Middle_Name: dsCollection.criteria.Indv_Middle_Name,
                Indv_Last_Name: dsCollection.criteria.Indv_Last_Name,
                Birth_Date: dsCollection.criteria.Birth_Date,
                Drvr_Lic_Num: dsCollection.criteria.Drvr_Lic_Num
              })
            "
            style="float: right"
            >New {{ profileLabel }}</unity-button-old>
        </span>

        <ep-max-row-warning [datasource]="dsCollection"></ep-max-row-warning>
        <div
          class="table-responsive"
          style="max-height: 400px; min-height: 400px; overflow-y: scroll; margin-top: 5px; border: 1px solid silver"
        >
          <table class="table table-select table-fixed-header" style="min-width: 700px">
            <tr>
              <th>First Name</th>
              <th>Middle Name</th>
              <th>Last Name</th>
              <th *ngIf="canViewDOBData == 'Y'">DOB</th>
              <th *ngIf="canViewDLData == 'Y'">Driver Lic #</th>
              <th>Contract #</th>
              <th>Effective</th>
            </tr>
            <tr
              *ngFor="let profile of profiles | epFilter : profileFilter.filter : profileFilter.filter.filterText"
              (click)="app.getSelectedText() && select(profile)"
            >
              <td>
                {{ profile.Indv_First_Name }}
              </td>
              <td>
                {{ profile.Indv_Middle_Name }}
              </td>
              <td>
                {{ profile.Indv_Last_Name }}
              </td>
              <td *ngIf="canViewDOBData == 'Y'">
                {{ profile.Birth_Date | epDate : 'mm/dd/yyyy' }}
              </td>
              <td *ngIf="canViewDLData == 'Y'">
                {{ profile.Drvr_Lic_Num }}
              </td>
              <td>
                {{ profile.Contract_Num }}
              </td>
              <td>
                {{ profile.Eff_Date | epDate : 'mm/dd/yyyy' }}
              </td>
            </tr>
            <tr class="col-12" *ngIf="!(profiles && profiles.length > 0) && this.modelChild.searchReady">
              <td>
                <span style="text-align: center"><i>No Profiles</i></span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </ep-row>
  </div>
</search-dialog-page>
